import script from "./MicroIcon.vue.ts?vue&type=script&setup=true&lang=ts&name=MicroIcon!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MicroIcon.vue?vue&type=script&setup=true&lang=ts&name=MicroIcon"
export * from "./MicroIcon.vue.ts?vue&type=script&setup=true&lang=ts&name=MicroIcon!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MicroIcon.vue?vue&type=script&setup=true&lang=ts&name=MicroIcon"

const __exports__ = script;

export default __exports__